export enum Tags {
  TEXT = '#text',
  A = 'A',
  BUTTON = 'BUTTON',
  H1 = 'H1',
  H2 = 'H2',
  H3 = 'H3',
  H4 = 'H4',
  H5 = 'H5',
  H6 = 'H6',
  UL = 'UL',
  OL = 'OL',
  P = 'P',
  IMG = 'IMG',
  IFRAME = 'IFRAME',
  STRONG = 'STRONG',
  EM = 'EM',
  BR = 'BR',
  SPAN = 'SPAN',
  LI = 'LI',
  TABLE = 'TABLE',
  TBODY = 'TBODY',
  TROW = 'TROW',
}

export interface HTMLElementSimplified {
  tag: Tags;
  attributes: Record<string, any>;
  classList: DOMTokenList;
  textContent?: string;
  innerHTML?: string;
  children: Array<HTMLElementSimplified>;
  parent?: HTMLElement;
}
